import { Dialog, Divider, Drawer, IconButton } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useSuperMutation } from '@vadiun/react-hooks-legacy';
import { ClientType } from 'app/client/main/models/ClientType';
import { useTransferReservationToValidateCount } from 'app/viaje/viajeTraslado/pendienteValidacion/context/TransferReservationToValidateCountContext';
import { useViajesTraslado } from 'app/viaje/services';
import { useFilters } from 'app/viaje/viajeTraslado/viajeTraslado/services/useFilters';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useCustomTablePagination } from 'shared/hooks/useCustomTablePagination';
import ViajeTrasladoBaseFilters from '../../viajeTraslado/components/ViajeTrasladoBaseFilters';
import ViajeTrasladoResumenModal from '../../viajeTraslado/components/ViajeTrasladoResumenModal';
import { ViajeAValidarDenyForm } from '../components/ViajeAValidarDenyForm';
import { ViajePendienteSolicitadoTable } from '../components/ViajePendienteSolicitadoTable';
import { TransferReservationToValidate } from '../models/TransferReservationPendingValidation';
import { BusType } from '../../viajeTraslado/models/TransferReservation';
import { createTableScrollHandler } from 'utils/tableUtils';

export const ViajePendienteSolicitadoPage = () => {
    const tableRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const tripRepository = useViajesTraslado();
  const { invalidateTransferReservationToValidateCount, invalidateVersion } =
    useTransferReservationToValidateCount();
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useFilters({
    dateFrom: moment().subtract(24, 'hours'),
    dateTo: moment().add(1, 'year'),
    clientId: null,
    serviceType: 'Todos',
    hasPriority: false,
    passangerName: '',
    street: '',
    locality: '',
    phone: '',
    client_phone: '',
    reservationId: '',
    departure_time_exceeded: false,
    driver_with_close_shift: false,
    assigned_driver_id: null,
    client_type: 'AllClient',
    business_unit: undefined,
    is_event: false,
    event_name: '',
    is_llt_pais: false,
    sent_reservations_platform: false,
    not_sent_reservations_platform: false,
    has_platform_id: false
  });
  const [locationsDetail, setLocationsDetail] = useState<{
    isOpen: boolean;
    details: TransferReservationToValidate | undefined;
  }>({ isOpen: false, details: undefined });
  const [denyDetails, setDenyDetails] = useState<{
    isOpen: boolean;
    reservation: any | undefined;
  }>({
    isOpen: false,
    reservation: undefined
  });

  const tablePagination = useCustomTablePagination((params: string) =>
    tripRepository.getAllTransferReservationToValidate(params)
  );

  const denyMutation = useSuperMutation(
    tripRepository.denyValidationTransferReservation
  );

  useEffect(() => {
    tablePagination.reload();
  }, [filters, invalidateVersion]);

  const handleDeny = async ({ observation, cancellationReasonClient }: { observation: string, cancellationReasonClient: string }) => {
    await denyMutation.mutate({ observation, cancellationReasonClient, id: denyDetails.reservation.id! });
    setDenyDetails({ isOpen: false, reservation: undefined });
    invalidateTransferReservationToValidateCount();
  };

  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);

  const getOptionsBuses = useCallback(async () => {
    const buses = await tripRepository.getOptionsBuses();
    setOptionsBuses(buses);
  }, [tripRepository]);

  useEffect(() => {
    getOptionsBuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={tableRef}>
      <PageHeader area="Operaciones - C.D.R." title="Validar App" />
      <PageContainer lessMargin>
        <ViajePendienteSolicitadoTable
          handlePageChange={createTableScrollHandler(tableRef)}
          tableProps={tablePagination}
          onLocationsDetails={(reservation) =>
            setLocationsDetail({ isOpen: true, details: reservation })
          }
          onDeny={(res) => {
            setDenyDetails({ isOpen: true, reservation: res });
          }}
          onValidate={(res) => {
            if (res.clientType === ClientType.business) {
              history.push(
                '/main/operations/cdr/app-validation/client-business/' + res.id
              );
            }
            if (res.clientType === ClientType.private) {
              history.push(
                '/main/operations/cdr/app-validation/client-particular/' + res.id
              );
            }
          }}
        />
      </PageContainer>
      <Drawer
        variant="persistent"
        anchor="right"
        open={showFilters}
        className="max-w-md"
      >
        <div>
          <IconButton onClick={() => setShowFilters(false)}>
            <ChevronRightIcon />
          </IconButton>
          <Divider />
          <ViajeTrasladoBaseFilters
            onSubmit={async (filters) => {
              setFilters(filters);
              setShowFilters(false);
            }}
            initialValues={filters}
            optionsBuses={optionsBuses}
          />
        </div>
      </Drawer>
      {locationsDetail.details && (
        <ViajeTrasladoResumenModal
          isOpen={locationsDetail.isOpen}
          reservation={locationsDetail.details!}
          handleClose={() =>
            setLocationsDetail({ isOpen: false, details: undefined })
          }
        />
      )}
      <Dialog
        open={denyDetails.isOpen}
        onClose={() =>
          setDenyDetails({ isOpen: false, reservation: undefined })
        }
      >
        <ViajeAValidarDenyForm onSubmit={handleDeny} reservation={denyDetails.reservation}/>
      </Dialog>
    </div>
  );
};
